


















import {Vue, Component, Prop, Ref, Watch} from "vue-property-decorator"
import {Getter, Mutation} from "vuex-class";
import GenericTemplate from "@/pages/Pages/Templates/GenericTemplate.vue";
import {MsgTransports} from "@/store/types";
import {TelegramOtpTemplateItemImpl} from "@/store/templates/types";
import {Route} from "vue-router";
import {cloneDeep} from "lodash";
import {InputWings, FormRowWings} from "wings-ui-components";

Component.registerHooks(["beforeRouteLeave"]);

@Component({components: {GenericTemplate, InputWings, FormRowWings}})
export default class TelegramOtpTemplate extends Vue {
  @Ref("genericTemplate") genericTemplate!: GenericTemplate;
  @Prop({default: null}) distribution: any;

  @Getter("templateObject") template: any;
  @Mutation('setTemplateObject') setTemplateObject: any

  private transport = MsgTransports.TELEGRAM_OTP;
  private templateObject = new TelegramOtpTemplateItemImpl();

  created() {
    this.setTemplate()
  }

  @Watch('$route.params.id', {immediate: true})
  onRouteIdChange(val: string, oldVal?: string) {
    if (val) {
      this.setTemplate()
    }
  }

  setTemplate() {
    this.setTemplateObject(cloneDeep(this.templateObject))
  }

  onLoadTemplate(template: any) {
    this.$emit('onLoadTemplate', template)
  }

  beforeRouteLeave(to: Route, from: Route, next: any) {
    this.genericTemplate.beforeLeave(to, from, next);
  }
}
